module.exports = __webpack_public_path__ + "static/media/sg6tj93.121b8250.png";